export const isJobSiteLocation = (location, jobSites = []) =>
  jobSites.some((jobSite) => jobSite.value === location);

export const getTransferType = (fromLocation, toLocation, jobSites = []) => {
  const isFromJobSite = isJobSiteLocation(fromLocation, jobSites);
  const isToJobSite = isJobSiteLocation(toLocation, jobSites);

  if (isFromJobSite && isToJobSite) return "internal";
  if (isFromJobSite) return "refund";
  if (!isToJobSite) return "external";
  return "transfer";
};

export const getDestinationLocationOptions = (
  fromLocation,
  warehouseLocations = [],
  jobSites = [],
) => {
  const warehouseDestinationOptions = isJobSiteLocation(fromLocation, jobSites)
    ? warehouseLocations
    : warehouseLocations.filter(
        (warehouseLocation) => warehouseLocation.value !== fromLocation,
      );

  return [
    {
      label: "Warehouse Locations",
      options: warehouseDestinationOptions,
    },
    { label: "Job Sites", options: jobSites },
  ];
};
